
import { defineComponent } from "vue";
import ArrowIcon from "@/components/icons/ArrowIcon.vue";

export default defineComponent({
  components: { ArrowIcon },
});
